import { FC } from 'react'
import ServicePage from 'components/ServicePage'
import PAGE_CONSTANT_TEXTS from 'constants/pageMetaTags'
import PageWrapper from 'components/PageWrapper'
import BreadcrumbList from 'components/StructuredData'

const Services: FC = () => {
  return (
    <PageWrapper {...PAGE_CONSTANT_TEXTS.services}>
      <BreadcrumbList nameH1="Web and Mobile App Development Services" />
      <ServicePage data={undefined} />
    </PageWrapper>
  )
}

export default Services
